import { routePath } from "../../routes/routePath";

export const pageInfoContact = {
  root: [
    { name: "ホームページ", url: routePath.homepage },
    { name: "お問い合わせ", url: routePath.contact },
  ],
  pageHeader: "お問い合わせ",
};
